import { render, staticRenderFns } from "./mobileGrowup.vue?vue&type=template&id=f52f0452&scoped=true&"
import script from "./mobileGrowup.vue?vue&type=script&lang=js&"
export * from "./mobileGrowup.vue?vue&type=script&lang=js&"
import style0 from "./mobileGrowup.vue?vue&type=style&index=0&id=f52f0452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52f0452",
  null
  
)

export default component.exports